import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico--sprite",
  "use": "ico--sprite-usage",
  "viewBox": "0 0 22.9 22.9",
  "content": "<symbol viewBox=\"0 0 22.9 22.9\" id=\"ico--sprite\">\n<path d=\"M17.6,17.6c-1.6,1.6-3.8,2.5-6.1,2.6V2.7c2.3,0,4.5,0.9,6.1,2.6c1.6,1.6,2.6,3.8,2.6,6.2S19.2,16,17.6,17.6z M11.4,0C5.1,0,0,5.1,0,11.4c0,0,0,0,0,0s0,0,0,0c0,6.3,5.1,11.4,11.4,11.4v0c6.3,0,11.4-5.1,11.4-11.4S17.7,0,11.4,0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol